import { sayEventAvModes, sayEventSignStatus, sayEventStatus } from '../eventSay';


export const buildEventDetail = (event, eventSign, say)=>{
    const avMode = event.avMode || [];
    const localeId = String(event.locale || "").trim().toLowerCase();
    const mySign = eventSign?.mySign;
    const signedCount = Array.isArray(event.gameEventUsers)
        ? event.gameEventUsers.length
        : Number(event.gameEventUsers) || 0;
    const title = event.name || event.gameSpace?.name || say("eventKindEvent");

    return {
        title,
        duration:say.duration(event.durationEst),
        localeLabel:localeId ? say.or(`localeFormOption${localeId[0].toUpperCase()}${localeId.slice(1)}`, localeId.toUpperCase()) : "",
        publishedAt:say.dateTime(event.publishedAt),
        statusLabel:sayEventStatus(say, event.status),
        accessLabel:event.isPublic ? say("eventAccessPublic") : say("eventAccessInviteOnly"),
        inviteLabel:!mySign && eventSign?.isInvited ? say("eventInviteActive") : "",
        recordLabel:sayEventAvModes(say, avMode),
        signTitle:mySign ? say("eventSignTitleSigned") : say("eventSignTitleUnsigned"),
        signLabel:mySign ? sayEventSignStatus(say, mySign.status) : event.isOpenToUsers ? say("eventSignOpen") : say("eventSignClosed"),
        isSigned:!!mySign,
        isOpen:!!event.isOpenToUsers,
        signedCount,
        sureCount:event.sureCount || 0,
        unsureCount:event.unsureCount || 0,
        minUsers:event.minUsers || 0,
        maxUsers:event.maxUsers || 0,
        maxUsersTotal:event.maxUsersTotal || event.maxUsers || 0,
        labels:{
            address:say("eventDetailAddress"),
            confirmed:say("eventDetailConfirmed"),
            crew:say("eventDetailCrew"),
            details:say("eventDetailCaption"),
            duration:say("eventDetailDuration"),
            eventKind:say("eventKindEvent"),
            id:say("eventDetailId"),
            minUsers:say("eventDetailMinUsers"),
            participation:say("eventDetailParticipation"),
            publishedAt:say("eventDetailPublishedAt"),
            startAt:say("eventDetailStartAt"),
            unsureCount:say("eventDetailUnsureCount")
        }
    };
};
